import React from 'react';

import { TRANSLATIONS as t } from 'constants/translations';

import styles from './VendingMachinePage.module.css'; // 동일한 스타일 사용

const ProductInfoDetailPage = ({ 
  selectedProduct, 
  tempCount, 
  setTempCount, 
  handleBackToList, 
  addToCart, 
  lang
}) => {
  if (!selectedProduct) return null;

  return (
    <div className={styles.detailPageView}>
      {/* 상단 네비게이션 바 */}
      <header className={styles.detailNav}>
        <button className={styles.navBackBtn} onClick={handleBackToList}>〈</button>
        <span className={styles.navTitle}>{t.detailInfo[lang]}</span>
        <div style={{ width: '60px' }}></div>
      </header>

      <main className={styles.detailScrollArea}>
        {/* 1. 상품 이미지 */}
        <div className={styles.detailMainImgWrapper}>
          <img src={selectedProduct.productImage || '/default-food.png'} alt="product" />
        </div>

        {/* 2. 상품 이름 */}
        <div className={styles.detailInfoSection}>
          <h2 className={styles.detailProductName}>
            {selectedProduct[`productName${lang}`] || selectedProduct.productNameKo}
          </h2>
        </div>

        {/* 3. 상품 수량 선택 */}
        <div className={styles.detailQuantitySection}>
          <div className={styles.detailCountControl}>
            <button onClick={() => setTempCount(Math.max(1, tempCount - 1))}>-</button>
            <span className={styles.detailCountNum}>{tempCount}</span>
            <button onClick={() => setTempCount(Math.min(selectedProduct.productCount, tempCount + 1))}>+</button>
          </div>
          <div className={styles.itemPrice}>
            {(selectedProduct.productPrice * tempCount).toLocaleString()}원
          </div>
        </div>

        <div className={styles.detailHorizontalLine} />

        {/* 4. 상품 상세 이미지 및 설명 */}
        <div className={styles.detailDescriptionArea}>
          <p className={styles.detailDescriptionText}>{selectedProduct[`productNote${lang}`]}</p>
          <div className={styles.detailSubImgWrapper}>
            {selectedProduct.productDetailImage ? (
              <img src={selectedProduct.productDetailImage} alt="detail" className={styles.fullWidthDetailImg} />
            ) : (
              <p className={styles.noDetailText}>{t.noDetailImg[lang]}</p>
            )}
          </div>
        </div>
      </main>

      {/* 하단 담기 버튼 */}
      <footer className={styles.detailFixedFooter}>
        <button className={styles.fullWidthAddBtn} onClick={addToCart}>
          {t.add[lang]} ({(selectedProduct.productPrice * tempCount).toLocaleString()}원)
        </button>
      </footer>
    </div>
  );
};

export default ProductInfoDetailPage;